<template>
  <section class="section--articles">
    <b-container>
      <b-row class="d-flex articles--alt">
        <b-col sm="6" lg="5" xl="5" class="mx-sm-auto mx-md-0">
          <div class="zoom-on-hover">
            <img :src="imgSrc" class="img-fluid" alt="">
          </div>
        </b-col>
        <b-col offset-xl="1" sm="6" lg="7" xl="6"
          class="d-flex flex-column justify-content-center
          pl-lg-5 pl-xl-0 mt-4 mt-sm-0">
          <h2 class="mb-2 mb-md-0">{{ article.title }}
            <span class="text--shadow-right">{{ article.title }}</span>
          </h2>
          <p class="pr-lg-5 pr-md-1 text-justify" v-html="article.header || article.content"></p>
          <div>
            <a class="btn btn-primary btn-sm" v-if="article.btn" :href="article.link">
              {{ article.btn }}
            </a>
          </div>
          <slot></slot>
        </b-col>
      </b-row>
    </b-container>
    <b-container v-if="!isStatic && !isTopSection">
      <div v-if="article.article_videos">
        <div v-for="(video, index) in article.article_videos" :key="index">
          <b-row class="article__extended">
            <b-col xl="5" lg="6" md="12">
              <div v-html="video.small_section"></div>
            </b-col>
            <b-col xl="6" lg="6" offset-xl="1"
              class="pt-3 pt-md-5 pt-lg-0 text-center">
              <iframe width="540" height="315" class="article__video"
                :src="video.video_url" allowfullscreen>
              </iframe>
            </b-col>
          </b-row>
        </div>
      </div>
      <b-row v-else class="article__extended">
        <b-col>
          <div v-html="article.small_section"></div>
        </b-col>
      </b-row>
      <template v-if="article.body">
         <b-row>
          <b-col>
            <div v-if="!isOpen"
              v-html="$options.filters.shortContent(article.body, contentLimit)"
              class="mb-3 mt-5">
            </div>
            <div v-else v-html="article.body"
              class="mb-3 mt-5">
            </div>
          </b-col>
        </b-row>
        <span v-if="!isOpen && article.body.length > contentLimit" @click="isOpen = !isOpen"
          class="article__more d-block">
          Read more...
        </span>
        <span v-if="isOpen && article.body.length > contentLimit" @click="isOpen = !isOpen"
          class="article__more d-block">
          Hide...
        </span>
      </template>
    </b-container>
  </section>
</template>

<script>
import { isDesktop } from '@/utils/responsive';
import filters from '@/utils/filters';

export default {
  props: ['article', 'isStatic', 'isTopSection'],
  data() {
    return {
      isOpen: false,
      isDesktop,
      contentLimit: 3000,
    };
  },
  computed: {
    imgSrc() {
      if (this.isStatic) {
        return `/static/assets/${this.article.photo}`;
      }
      return this.article.photo.url ?
        `${process.env.SERVER_URL}/${this.article.photo.url}` :
        `${process.env.SERVER_URL}/${this.article.photo}`;
    },
  },
  filters: {
    shortContent: filters.shortContent,
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/helpers/_variables.scss";
@import "../styles/helpers/_include-media.scss";

.section--articles {
  padding-bottom: 100px;
  padding-top: 100px;
  @include media("<lg") {
    padding: 50px 0;
  }
  @include media("<md") {
    padding: 40px 0 20px;
  }
}
.article {
  &__alt {
    padding-right: 40px;
  }
  &__extended {
    padding-top: 100px;
    @include media("<lg") {
      margin-top: 50px;
      padding-top: 50px;
      padding-bottom: 50px;
      background-color: $color--gray-4;
      @include media("<md") {
        padding: 40px 0;
      }
    }
  }
  &__more {
    color: $color--orange;
    cursor: pointer;
    font-size: 16px;
    display: inline-block;
    text-align: right;
    @include media("<lg") {
      padding-right: 25px;
      padding-top: 20px;
      padding: 20px 25px 30px;
      font-size: 12px;
    }
  }
  &__video {
    @include media('<xl') {
      width: 450px;
      height: 280px;
    }
    @include media('<md') {
      width: 440px;
    }
    @include media('<sm') {
      width: 280px;
      height: 240px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Article.vue